/* eslint-disable no-nested-ternary */
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { isMobile, mobileModel, osVersion, osName } from 'react-device-detect';
import { CompraService } from '../../services';
import useAPIError from '../../hooks/useAPIError';
import { useAuthStore } from '../../store/AuthContext';
import ModalConfirmacion from '../../components/ModalConfirmacion';
import { HostProvider } from '../../utils/HostProvider';

interface Props {
  activo: boolean;
  visible: boolean;
  setVisible: (visible: boolean) => void;
  setActivo: (activo: boolean) => void;
}

const PapelOptionState: FC<Props> = (props) => {
  const { addError, addErrorBack } = useAPIError();
  const isEroski = HostProvider.isEroski();

  const { t } = useTranslation();
  const { activo, visible, setVisible, setActivo } = props;
  const [showModal, setShowModal] = useState(false as boolean);
  const dataUser = useAuthStore();
  const titleKey = activo
    ? 'compras.confirmar-desactivar-title'
    : 'compras.confirmar-ativar-title';
  const textKey = activo
    ? isEroski
      ? 'compras.confirmar-desactivar-text'
      : 'caprabo.compras.confirmar-desactivar-text'
    : isEroski
    ? 'compras.confirmar-ativar-text'
    : 'caprabo.compras.confirmar-ativar-text';
  const updateTicket = () => {
    let option = 0;
    const isApp = dataUser.user.isApp === 'true';
    if (!activo) {
      option = 1;
    }
    const ticketsInputJson = {
      action: option,
      fromApp: isApp ? 'app_club' : 'web',
      modelo: isMobile ? mobileModel : `${osName} ${osVersion}`,
    };
    CompraService.ticketOption(ticketsInputJson)
      .then((response) => {
        if (response.data.error) {
          addErrorBack(response.data);
        } else {
          setActivo(!activo);
        }
      })
      .catch((e) => {
        console.log(e);
        addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'ERROR');
      });
  };
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const emptymethod = () => {};
  return (
    <>
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label className="switch">
        <input
          id="input-papel"
          type="checkbox"
          checked={activo}
          onClick={() => {
            setVisible(!visible);
            setShowModal(!showModal);
          }}
          readOnly
          value={activo ? 1 : 0}
        />
        <span className="slider-switch round" />
      </label>
      <ModalConfirmacion
        isBig
        isSmall={false}
        textCentered={false}
        showModal={showModal}
        setShowModal={setShowModal}
        title={t(titleKey)}
        textHTMLContent={t(textKey)}
        doAceptar={updateTicket}
        doClose={emptymethod}
        showCancel
        acceptButtonTextKey={t('global.confirm')}
      />
    </>
  );
};

export default PapelOptionState;
